import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1472162072942-cd5147eb3902?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjaGlsZCUyMHNtaWxpbmclMjByZWFkaW5nJTIwYm9vayUyMHRoZXJhcGlzdHxlbnwwfHx8fDE3ODU3NDY1NTd8MA&ixlib=rb-4.1.0&q=85";

const chapters = [
  {
    n: "01",
    title: "Meet the child first",
    body: "Before goals or plans, we watch, listen and play. Every plan starts with who your child already is.",
  },
  {
    n: "02",
    title: "Small wins, every day",
    body: "Progress compounds. We break big milestones into tiny, celebrated steps that build real confidence.",
  },
  {
    n: "03",
    title: "Families are the team",
    body: "You know your child best. We coach and equip you so the growth continues long after each session.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section id="approach" className="py-24 md:py-32 bg-brand-accent/40">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.4 }}
            className="lg:col-span-5"
          >
            <p className="text-sm tracking-[0.2em] uppercase text-brand-secondary mb-5">Our approach</p>
            <h2 className="font-display font-light text-4xl sm:text-5xl tracking-tight text-brand-primary leading-tight">
              A philosophy of patience, play and progress.
            </h2>
            <div className="mt-8 overflow-hidden rounded-3xl">
              <img src={IMG} alt="Child reading a book on a bench" className="h-[300px] w-full object-cover" />
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5 lg:pl-8">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                data-testid={`manifesto-chapter-${i}`}
                className={`rounded-3xl bg-brand-bg border border-brand-primary/10 p-8 hover:-translate-y-1 transition-transform duration-300 ${
                  i === 2 ? "sm:col-span-2" : ""
                }`}
              >
                <span className="font-display text-4xl text-brand-secondary">{c.n}</span>
                <h3 className="font-display text-2xl text-brand-primary mt-4 mb-3">{c.title}</h3>
                <p className="text-brand-ink/70 leading-relaxed">{c.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
